/* eslint-disable @typescript-eslint/no-unsafe-assignment -- interfacing with untyped Ember models during migration */
/* eslint-disable @typescript-eslint/no-unsafe-member-access -- interfacing with untyped Ember models during migration */
/* eslint-disable @typescript-eslint/no-unsafe-call -- interfacing with untyped Ember models during migration */
import { useState } from 'react';
import { useNavigate } from '@repo/poly-hooks/routing';
import { useParams } from 'react-router';
import { useEmberService } from '@qonto/react-migration-toolkit/react/hooks';
import { useToast } from '@repo/design-system-kit';
import { useIntl } from 'react-intl';
import { BusinessActivity as BusinessActivityComponent } from '@repo/customer-registration-kit/common';
import { NotFoundError } from '@ember-data/adapter/error';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { BackButton } from '../../components/back-button';
import styles from './business-activity.module.css';

export function BusinessActivity(): React.JSX.Element {
  const navigate = useNavigate();
  const { registrationId } = useParams<{ registrationId: string }>();
  const [loadingActivity, setLoadingActivity] = useState<string | null>(null);
  const { formatMessage } = useIntl();
  const { showToast } = useToast();

  const store = useEmberService('store');
  const apiFlowManager = useEmberService('apiFlowManager');

  function handleGoBack(): void {
    navigate(`/registrations/${registrationId}/nature-of-ops`, { replace: true });
  }

  async function handleSelect(activityType: string): Promise<void> {
    setLoadingActivity(activityType);

    try {
      let registration;
      let organization;

      /**
       * Try to load the registration model first. If it's not found (404),
       * fall back to partner-registration model. This follows the same pattern
       * as the main registration route to handle both registration types.
       */
      try {
        // @ts-expect-error -- interfacing with untyped Ember models during migration
        registration = await store.findRecord('registration', registrationId, {
          reload: true,
          include: 'organization',
        });
        organization = await registration.get('organization');
      } catch (error) {
        if (error instanceof NotFoundError) {
          // @ts-expect-error -- interfacing with untyped Ember models during migration
          apiFlowManager.isPartnersService = false;
          // @ts-expect-error -- interfacing with untyped Ember models during migration
          registration = await store.findRecord('partner-registration', registrationId, {
            reload: true,
          });
          organization = await registration.get('organization');
        } else {
          throw error;
        }
      }

      organization.set('businessActivityEntityType', activityType);
      await organization.save();

      navigate(`/registrations/${registrationId}/business-finances`, { replace: true });
    } catch {
      showToast({
        type: 'error',
        text: formatMessage({ id: 'errors.internal-server-error' }),
      });
    } finally {
      setLoadingActivity(null);
    }
  }

  return (
    <MainLayout>
      <div className={styles.content}>
        <BusinessActivityComponent loadingActivity={loadingActivity} onSelect={handleSelect} />
        <BackButton onClick={handleGoBack} />
      </div>
    </MainLayout>
  );
}
